'use client'
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      },
    },
  };

const AboutWafra = () => {
  const t = useTranslations("about");

  return (
    <section
      className="py-16 md:py-24 px-4 md:px-8 my-gradient-bg"
    >
      <div className="max-w-6xl mx-auto">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center"
        >
          {/* Text Content - Arabic */}
          <div className="rtl">
            <motion.div variants={itemVariants}>
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-1" style={{ backgroundColor: "var(--color-gold-bright)" }}></div>
                <h2
                  className="text-2xl md:text-3xl font-bold"
                  style={{
                    color: "var(--color-dark-navy)",
                    fontFamily: "var(--font-arabic)"
                  }}
                >
                  {t("title")}
                </h2>
              </div>
            </motion.div>

            <motion.p
              variants={itemVariants}
              className="text-lg md:text-xl leading-relaxed mb-4"
              style={{
                color: "var(--color-gray-light)",
                fontFamily: "var(--font-arabic)",
                lineHeight: "1.8"
              }}
            >
              {t("paragraph1")}
            </motion.p>

            <motion.p
              variants={itemVariants}
              className="text-lg md:text-xl leading-relaxed"
              style={{
                color: "var(--color-gray-light)",
                fontFamily: "var(--font-arabic)",
                lineHeight: "1.8"
              }}
            >
              {t("paragraph2")}
            </motion.p>
          </div>

          {/* Visual Element */}
          <motion.div
            variants={itemVariants}
            className="flex justify-center"
          >
            <div className="relative w-full max-w-md">
              {/* Floating card effect */}
              <motion.div
                initial={{ rotate: 0 }}
                whileInView={{
                  rotate: 6,
                  transition: {
                    duration: 0.8,
                    delay: 0.3,
                    ease: "easeInOut"
                  }
                }}
                viewport={{ once: false }}
                className="absolute inset-0 rounded-2xl z-0"
                style={{ backgroundColor: "var(--color-gold-bright)" }}
              ></motion.div>

              <motion.div
                whileHover={{ y: -10 }}
                className="relative rounded-2xl overflow-hidden shadow-xl z-10"
              >
                <div
                  className="aspect-video flex items-center justify-center p-8"
                  style={{ backgroundColor: "var(--color-dark-navy)" }}
                >
                  <motion.img
                    src="/imgs/logo-bg.png"
                    alt="Wafra Logo"
                    className="w-40 md:w-56 object-contain"
                    animate={{
                      scale: [1, 1.05, 1],
                    }}
                    transition={{
                      duration: 2,
                      repeat: Infinity,
                      ease: "easeInOut",
                    }}
                  />
                </div>
              </motion.div>


              {/* Animated decorative elements */}
              <motion.div
                className="absolute -bottom-6 -right-6 w-24 h-24 rounded-full"
                style={{ backgroundColor: "var(--color-olive-dark)" }}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{
                  opacity: 0.2,
                  scale: 1,
                  transition: { delay: 0.5 }
                }}
                viewport={{ once: false }}
              ></motion.div>
              <motion.div
                className="absolute -top-6 -left-6 w-16 h-16 rounded-full"
                style={{ backgroundColor: "var(--color-gold-bright)" }}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{
                  opacity: 0.3,
                  scale: 1,
                  transition: { delay: 0.7 }
                }}
                viewport={{ once: false }}
              ></motion.div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutWafra;